import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import {SITE} from 'features/ui/enums';
import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';
import {useUiStore} from 'features/ui/store/useUiStore';
import {getCurrentSite} from 'features/services/utils/env-helper';
import {getFormattedMessage} from 'features/services/utils/language-helper';
import {gtmEventsInterestSignupOpen} from 'features/services/googleTagManager/events';

import './style.scss';

import {Button, ButtonColor, ButtonSize, ButtonType} from 'components/atoms/LinksAndButtons/Button';
import {InterestFormModal} from 'components/modals/General/InterestFormModal';
import {ModalPosition, useModal} from "features/modal/hooks/useModal";
import {RealEstateAgent} from "features/template/viewModels/ResidenceStage";
import {useAuth} from "features/authentication/hooks/useAuth";

interface Props {
    isVipperiod: boolean;
    isStage?: boolean;
    stageName: string;
    stageId: string;
    stageStatus: string;
    objectId?: string;
    agent: RealEstateAgent;
    hideMessageField: boolean;
    basicSignupPulText: string;
    interestDone: boolean;
    setInterestDone: (done: boolean) => void;
}

export const InterestButton: React.FunctionComponent<Props> = (props) => {
    const { open } = useModal();
    const {user} = useAuth();
    const setInterestModalVisibility = useUiStore((state) => state.setInterestModalVisibility);
    const childSite = getCurrentSite()===SITE.SENIORGARDEN || getCurrentSite()===SITE.BORATT;
    const isMobile = useDeviceStore(selectIsMobile);

    if (user?.isLegalEntity) return null;

    const secondary = props.isVipperiod && props.isStage && !isMobile;
    const lightBtn = childSite && !isMobile && !secondary;

    const onInterestClick = () => {
        gtmEventsInterestSignupOpen(props.isStage ? "default" : "object")();

        setInterestModalVisibility(true);

        open(
            <InterestFormModal
                stageName={props.stageName}
                stageId={props.stageId}
                stageStatus={props.stageStatus}
                objectId={props.objectId}
                agent={props.agent}
                interestType="default"
                interestDone={props.interestDone}
                setInterestDone={props.setInterestDone}
                hideMessageField={props.hideMessageField}
                basicSignupPulText={props.basicSignupPulText}
                labelPrefix="modal-"
                doneCallback={props.isStage ? () => {} : onInterestDone}
            />,
            { fullscreen: false, ariaLabel: getFormattedMessage('jm.components.InterestForm.header'), position: ModalPosition.RIGHT, triggerElementId: 'residenceInterestButton-' + props.stageId, closeCallback: () => setInterestModalVisibility(false) }
        );
    };

    const onInterestDone = () => {
        setInterestModalVisibility(false);
    };

    return (
        <Button
            id={'residenceInterestButton-' + props.stageId}
            onClick={onInterestClick}
            buttonColor={(secondary || lightBtn) ? ButtonColor.LIGHT : ButtonColor.CTA} 
            buttonSize={ButtonSize.DEFAULT} 
            buttonType={secondary ? ButtonType.GHOST : ButtonType.DEFAULT} 
        >
            <FormattedMessage id='jm.components.StagePage.buttonTextInterest' />
        </Button>
    )
};
